import en from 'static/images/common/flags/UK.svg';
import th from 'static/images/common/flags/Thailand.svg';
import chm from 'static/images/common/flags/China.svg';
import id from 'static/images/common/flags/Indonesia.svg';
import vn from 'static/images/common/flags/Vietnam.svg';
import es from 'static/images/common/flags/Spain.svg';

export const LANGUAGE = {
  ENGLISH: 'en',
  THAI: 'th',
  CHINESE: 'ch',
  CANTON: 'chm',
  INDONESIAN: 'id',
  VIETNAMESE: 'vn',
  SPANISH: 'es',
};

export const DEFAULT_LANG = LANGUAGE.ENGLISH;

export const LANGUAGES = [
  { language: LANGUAGE.ENGLISH, icon: en, label: 'English' },
  { language: LANGUAGE.THAI, icon: th, label: 'แบบไทย' },
  { language: LANGUAGE.CANTON, icon: chm, label: '普通话' },
  { language: LANGUAGE.INDONESIAN, icon: id, label: 'bahasa Indonesia' },
  { language: LANGUAGE.VIETNAMESE, icon: vn, label: 'Tiếng Việt' },
  { language: LANGUAGE.SPANISH, icon: es, label: 'Español' },
];
